import { DynamicContentType } from '../../types/content.types.js'
import { FileEntryBM } from '../../types/fileEntry.types.js'
import { LucideIconName } from '../../types/lucide.types.js'

export interface ContactFormPayload {
  formData: Record<string, string>
  formUuid: string
}

export type FormField = {
  type: 'text' | 'email' | 'textarea' | 'tel'
  name: string
  desc?: string
  width: 'full' | 'half'
  required: boolean
}

export type FormData = {
  fields: FormField[]
  submitText: string
  successText: string
  contactEmail?: string
  marginBottom?: string
  marginTop?: string
  senderConfirmationEmailSubject?: string
  senderConfirmationEmailBody?: string // html
  senderConfirmationEmailImage?: FileEntryBM
}

export const getDefaultSenderConfirmationSubject = (customerName: string) =>
  `Ditt meddelande till ${customerName} har tagits emot`

export const getDefaultSenderConfirmationHtml = (customerName: string) =>
  `<p>Ditt meddelande till ${customerName} har tagits emot.<br/>${customerName} kommer att återkomma till dig på denna mailadress så snart de kan.</p>`

export const form: DynamicContentType<FormData> = {
  name: 'form',
  viewName: 'Formulär',
  featureKey: 'form',
  icon: LucideIconName.Mail,
  uuid: '',
  default: true,
  data: {
    fields: [],
    submitText: 'Skicka',
    successText: 'Tack för ditt meddelande. Vi återkommer så snart vi kan.',
  },
}
